import React, { useState, useId, useEffect } from "react";

const Button = ({
  label = "JOIN THE SUCCESS STORIES",
  onClick,
  width = "100%",
  height = "auto",
  padding = "",
  margin = "0",
  fontWeight = 500,
  fontSize = 22,
  textColor = "#000",
  gradientStart = "#ff4d1d",
  gradientEnd = "#d70a84",
  fontFamily = "Proxima Nova Bold, sans-serif",
  style = {},
  pink,
  orange,
  textAlign="left",
  fill
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [textWhite,setTextWhite] = useState(false);
  const clipId = useId();

  let textAnchor, xPos;

  switch (textAlign) {
    case "left":
      textAnchor = "start";
      xPos = "20%";
      break;
    case "right":
      textAnchor = "end";
      xPos = "395";
      break;
    default:
      textAnchor = "middle";
      xPos = "55%";
  }

  const baseFill = fill || (pink ? "#890295" : orange ? "#ff4d1d" : "transparent");
  const hoverFill = "url(#hoverFillGradient)";
  const pathD = "M369.72.75H35.96C17.72.75,2.71,14.53.75,32.24h43.98l-12.77-12.77c-1.54-1.54-1.54-4.04,0-5.58,1.54-1.54,4.04-1.54,5.58,0l19.41,19.41c.79.79,1.17,1.84,1.15,2.88.02,1.04-.35,2.09-1.15,2.88l-19.41,19.41c-1.54,1.54-4.04,1.54-5.58,0-1.54-1.54-1.54-4.04,0-5.58l12.77-12.77H.75c1.96,17.71,16.97,31.49,35.21,31.49h333.76c19.57,0,35.43-15.86,35.43-35.43h0c0-19.57-15.86-35.43-35.43-35.43Z";
  
  useEffect(() => {
    let timeout;
    if (isHovered) {
      // Wait 2 seconds after hover before changing text color
      timeout = setTimeout(() => {
        setTextWhite(true);
      }, 200);
    } else {
      // Reset immediately when not hovered
      setTextWhite(false);
      clearTimeout(timeout);
    }

    return () => clearTimeout(timeout);
  }, [isHovered]);

  return (
    <div
      style={{
        display: "inline-block",
        padding,
        margin,
        cursor: "pointer",
        ...style,
           }}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 405.91 72.37"
        width={window.innerWidth < 500 ? "100%" : width}
height={window.innerWidth < 500 ? "auto" : height}
        style={{ 
          display: "block",
          overflow: "visible"
        }}
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="0"
            y1="36.18"
            x2="405.91"
            y2="36.18"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor={gradientStart} />
            <stop offset="1" stopColor={gradientEnd} />
          </linearGradient>
          
          <clipPath id={clipId}>
            <rect 
              x="0" 
              y="0" 
              width={isHovered ? "406" : "0"} 
              height="73"
              style={{
                transition: "width 0.5s ease-in-out"
              }}
            />
          </clipPath>
        </defs>
         <defs>
    <linearGradient id="hoverGradient" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stopColor="#7e1790" />
      <stop offset="100%" stopColor="#d70a84" />
    </linearGradient>
  </defs>

        <g style={{
          transition: "transform 0.3s ease",
          transform: isHovered ? "scale(1.05)" : "scale(1)",
          transformOrigin: "center center",
          transformBox: "fill-box"
        }}>
          {/* Base path */}
          <path
            fill={baseFill}
            stroke="url(#linear-gradient)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={textWhite?"0":"2"}
            d={pathD}
            style={{
    transition: 'stroke-width 0.3s ease, fill 0.3s ease'
  }}
          />
          
          {/* Red overlay that reveals from left */}
          <path
            fill="url(#hoverGradient)"
            d={pathD}
            clipPath={`url(#${clipId})`}
          />
        </g>

        <text
        x={xPos}
        y="52%"
        dominantBaseline="middle"
        textAnchor={textAnchor}
        fill={textWhite ? "#FFFFFF" : textColor}  // changes after 2s
        fontFamily={fontFamily}
        fontWeight={fontWeight}
        fontSize={fontSize}
        style={{ transition: "fill 0.3s ease" }}
      >
        {label}
      </text>
      </svg>
    </div>
  );
};

export default Button;